var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPopularity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.462 4.18304L2.57132 15.0721C2.47565 15.1684 2.40672 15.288 2.37132 15.419L0.0275632 24.0128C-0.00870396 24.1457 -0.00918967 24.2858 0.0261553 24.4189C0.0615002 24.5521 0.131419 24.6735 0.228824 24.7709C0.326228 24.8683 0.447655 24.9382 0.580794 24.9736C0.713933 25.0089 0.85405 25.0084 0.986941 24.9722L9.58072 22.6284C9.71175 22.593 9.83131 22.5241 9.92759 22.4284L20.8167 11.5378L13.462 4.18304Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3149 4.72686L20.2742 0.68622C19.8347 0.246834 19.2387 0 18.6172 0C17.9957 0 17.3997 0.246834 16.9602 0.68622L15.1211 2.52529L22.4758 9.88L24.3149 8.04093C24.7543 7.60141 25.0011 7.00537 25.0011 6.38389C25.0011 5.76241 24.7543 5.16638 24.3149 4.72686Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPopularity);
export default __webpack_public_path__ + "static/media/Edit Popularity.e1401e3bba48418ac8ebb72b4b1ce8bc.svg";
export { ForwardRef as ReactComponent };